import { call, delay } from 'redux-saga/effects'

import api from 'Src/api'

const LIST_BOTS_URL = 'v1/bot-profiles'
const DELETE_BOT_URL = 'v1/bot-profiles/:id'

export const fetchBots = function* () {
  const response = yield call(api.get, LIST_BOTS_URL)
  return response.data
}

// TODO: helper should only invoke the API and return response
// TODO: fetchBots must be handled by bot saga
export const deleteBot = function* (botId) {
  try {
    yield call(api.delete, DELETE_BOT_URL, {
      urlParams: { id: botId }
    })
    yield delay(100)
    yield call(fetchBots)
  } catch (err) {
    console.error('Unable to delete bot', err)
  }
}
